import axios from 'axios';
import { serverHost } from '../../http_common.js';
const prefix = {CEO:'ceo',ED:'executive-director',SDD:'sdd',FDC:'fdc'};
export async function loadGeoOverview(role,token,signal) {
  if (!prefix[role] || !token) throw new Error('An authenticated staff session is required.');
  const {data}=await axios.get(`${serverHost}/${prefix[role]}/geo/overview`,{headers:{Authorization:`Bearer ${token}`},signal,timeout:30000});
  return data.data;
}
export async function loadGeoState(role,token,code,{category='clients',search='',page=1,filter='ALL'}={},signal){
  if (!prefix[role] || !/^NG-[A-Z]{2}$/.test(code)) throw new Error('Invalid geographic selection.');
  const {data}=await axios.get(`${serverHost}/${prefix[role]}/geo/states/${code}`,{headers:{Authorization:`Bearer ${token}`},params:{category,search,page,filter},signal,timeout:30000});
  return data.data;
}

export async function searchGeoRecords(role,token,{category='clients',search,page=1}={},signal){
  if(!prefix[role] || !token)throw new Error('An authenticated staff session is required.');
  const {data}=await axios.get(`${serverHost}/${prefix[role]}/geo/search`,{
    headers:{Authorization:`Bearer ${token}`},params:{category,search,page},signal,timeout:30000
  });
  return data.data;
}

export async function loadGeoInsights(role,token,signal){
 if(!prefix[role]||!token)throw new Error('An authenticated staff session is required.');
 const {data}=await axios.get(`${serverHost}/${prefix[role]}/geo/insights`,{headers:{Authorization:`Bearer ${token}`},signal,timeout:30000});
 return data.data;
}
export async function loadGeoActivity(role,token,page=1,signal){
 if(!prefix[role]||!token)throw new Error('An authenticated staff session is required.');
 const {data}=await axios.get(`${serverHost}/${prefix[role]}/geo/activity`,{headers:{Authorization:`Bearer ${token}`},params:{page},signal,timeout:30000});
 return data.data;
}

export async function loadGeoStaffProfile(role,token,staffId,signal){
 if(!prefix[role]||!token||! /^[a-zA-Z0-9_-]{1,80}$/.test(String(staffId)))throw new Error('Invalid authorized staff selection.');
 const {data}=await axios.get(`${serverHost}/${prefix[role]}/geo/staff/${encodeURIComponent(staffId)}`,
   {headers:{Authorization:`Bearer ${token}`},signal,timeout:30000});
 return data.data;
}

export async function loadGeoTrends(role,token,days=14,signal){
 if(!prefix[role]||!token)throw new Error('An authenticated staff session is required.');
 const {data}=await axios.get(`${serverHost}/${prefix[role]}/geo/trends`,{
   headers:{Authorization:`Bearer ${token}`},params:{days},signal,timeout:30000});
 return data.data;
}
export async function loadGeoStateInsights(role,token,code,signal){
 if(!prefix[role]||!token||!/^NG-[A-Z]{2}$/.test(code))throw new Error('Invalid geographic selection.');
 const {data}=await axios.get(`${serverHost}/${prefix[role]}/geo/states/${code}/insights`,{
   headers:{Authorization:`Bearer ${token}`},signal,timeout:30000});
 return data.data;
}

export async function loadGeoOperationsSummary(role,token,signal){
 if(!prefix[role]||!token)throw new Error('An authenticated staff session is required.');
 const {data}=await axios.get(`${serverHost}/${prefix[role]}/geo/operations/summary`,{
   headers:{Authorization:`Bearer ${token}`},signal,timeout:30000});
 return data.data;
}
export async function loadGeoOperationsTimeline(role,token,{days=1,page=1}={},signal){
 if(!prefix[role]||!token||![1,7,30].includes(Number(days)))throw new Error('Invalid operations timeline request.');
 const {data}=await axios.get(`${serverHost}/${prefix[role]}/geo/operations/timeline`,{
   headers:{Authorization:`Bearer ${token}`},params:{days,page},signal,timeout:30000});
 return data.data;
}
export async function loadGeoOperationsPresence(role,token,signal){
 if(!prefix[role]||!token)throw new Error('An authenticated staff session is required.');
 const {data}=await axios.get(`${serverHost}/${prefix[role]}/geo/operations/presence`,{
   headers:{Authorization:`Bearer ${token}`},signal,timeout:30000});
 return data.data;
}

export async function loadGeoPerformance(role,token,{month,page=1,pace='ALL',state='ALL',sort='registrations'}={},signal){
 if(!prefix[role]||!token)throw new Error('An authenticated staff session is required.');
 if(month && !/^20\d{2}-(0[1-9]|1[0-2])$/.test(month))throw new Error('Invalid performance month.');
 const {data}=await axios.get(`${serverHost}/${prefix[role]}/geo/performance`,{
   headers:{Authorization:`Bearer ${token}`},params:{month,page,pace,state,sort},signal,timeout:30000});
 return data.data;
}

export async function loadGeoPerformanceComparison(role,token,months=6,signal){
 if(!prefix[role]||!token)throw new Error('An authenticated staff session is required.');
 if(![3,6,12].includes(Number(months)))throw new Error('Invalid comparison period.');
 const {data}=await axios.get(`${serverHost}/${prefix[role]}/geo/performance/comparison`,{
  headers:{Authorization:`Bearer ${token}`},params:{months},signal,timeout:30000});
 return data.data;
}
